import { render, staticRenderFns } from "./BtnIconAdd.vue?vue&type=template&id=4f1ba63c&scoped=true&"
import script from "./BtnIconAdd.vue?vue&type=script&lang=js&"
export * from "./BtnIconAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ba63c",
  null
  
)

export default component.exports